var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer-position-boilerplates"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('OfferPositionBoilerplatesTable',{on:{"create-offer-position-boilerplate":_vm.onCreateOfferPositionBoilerplate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }